import { useState } from "react";
import { Play, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { DONATE_URL, CONTACT_URL } from "./data";
import { SmartLink } from "./SmartLink";

const VIDEO_ID = "m3B4PAPbJwY";

const Video = () => {
  const [play, setPlay] = useState(false);
  return (
    <div data-testid="youtube-video-container" className="relative aspect-video rounded-[28px] overflow-hidden bg-black shadow-[0_40px_80px_-30px_rgba(0,0,0,0.6)]">
      {play ? (
        <iframe
          className="absolute inset-0 w-full h-full"
          src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1`}
          title="Wings of Fire Foundation video"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <button onClick={() => setPlay(true)} data-testid="youtube-play-button" className="group absolute inset-0 w-full h-full" aria-label="Play video">
          <img src={`https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`} alt="Video thumbnail" className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-[opacity,transform] duration-700" />
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-[#CF5C0F] flex items-center justify-center pulse-ring">
              <Play className="w-8 h-8 text-white fill-white ml-1" />
            </span>
          </span>
        </button>
      )}
    </div>
  );
};

export const Support = () => (
  <section id="support" data-testid="support-section" className="relative bg-[#1B3824] text-[#FAF7F2] py-24 lg:py-36 overflow-hidden">
    <img src="/images/wings.png" alt="" className="absolute -right-32 top-10 w-[520px] opacity-[0.08] pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <div className="lg:col-span-5">
        <Eyebrow light testId="support-eyebrow">Support Us</Eyebrow>
        <Reveal>
          <h2 className="font-serif text-5xl sm:text-6xl text-white mt-6 leading-[0.95] tracking-tight">
            Donate today to help us continue <em className="text-[#F2B36B]">our mission.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 text-lg text-[#E2E8E4] leading-relaxed">
            Wings of Fire Foundation is committed to supporting the most vulnerable children and young adults with disabilities in Delhi’s urban slums, ensuring they can lead independent and fulfilling lives.
          </p>
          <p className="mt-4 text-base text-[#C9D6CD] leading-relaxed">
            You can make a difference by volunteering, donating, or spreading the word about WOFF mission. Contact us to learn more.
          </p>
        </Reveal>
        <Reveal delay={0.2} className="mt-10 flex flex-wrap gap-4">
          <SmartLink href={DONATE_URL} data-testid="support-donate-cta-button" className="btn-fire btn-lg">
            Donate <ArrowUpRight className="w-5 h-5" />
          </SmartLink>
          <SmartLink href={CONTACT_URL} data-testid="support-contact-button" className="btn-ghost-light btn-lg">
            Volunteer with us
          </SmartLink>
        </Reveal>
      </div>
      <Reveal delay={0.15} className="lg:col-span-7">
        <Video />
      </Reveal>
    </div>
  </section>
);
